import { useRef } from 'react';
import { Dropdown } from '@ui/kit';
import { tableStyles } from '@ui/kit/selectors';
import { useToggleState } from '@utils/react';
import { ContextAction } from './actions.context.js';
import { CopyAction } from './actions.copy.js';
import { DeleteAction } from './actions.delete.js';
import { OpenAction } from './actions.open.js';
import { SettingsAction } from './actions.settings.js';
import { ShareAction } from './actions.share.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Actions({
  item,
  onActionClick
}) {
  const dropdownTriggerRef = useRef(null);
  const [showDropdown, actions] = useToggleState();
  return /*#__PURE__*/jsxs("div", {
    role: "cell",
    className: tableStyles.actions.actions,
    children: [/*#__PURE__*/jsx(OpenAction, {
      course: item,
      onClick: () => onActionClick?.("preview")
    }), /*#__PURE__*/jsx(ShareAction, {
      course: item,
      onClick: () => onActionClick?.("share")
    }), /*#__PURE__*/jsx(ContextAction, {
      showContextmenu: showDropdown,
      dropdownTriggerRef: dropdownTriggerRef,
      onClick: actions.toggle
    }), /*#__PURE__*/jsx(Dropdown, {
      active: showDropdown,
      triggerRef: dropdownTriggerRef,
      onClose: actions.disable,
      children: /*#__PURE__*/jsxs("div", {
        className: tableStyles.actions.dropdownActions,
        children: [/*#__PURE__*/jsx(CopyAction, {
          course: item,
          onCopied: () => {
            actions.disable();
            onActionClick?.("duplicate");
          }
        }), /*#__PURE__*/jsx(DeleteAction, {
          course: item,
          closeDropdown: () => {
            actions.disable();
            onActionClick?.("delete");
          }
        }), /*#__PURE__*/jsx(SettingsAction, {
          course: item,
          onSettingsOpened: () => {
            actions.disable();
            onActionClick?.("settings");
          }
        })]
      })
    })]
  });
}

export { Actions };
//# sourceMappingURL=actions.js.map
